import { getAuthToken } from 'src/store/config';
import * as api from './api';

export const fetchData = async () => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(`${process.env.REACT_APP_ADMIN_API_URL}`);
  return response;
}

